import type { ReactNode } from "react";

import { AppLink } from "../layout/AppLink";

type Props = {
  label: string;
  value: ReactNode;
  hint?: string;
  to?: string;
};

export function StatCard({ label, value, hint, to }: Props) {
  const className = `admin-stat${to ? " admin-stat--action" : ""}`;

  const content = (
    <>
      <p className="admin-stat__label">{label}</p>
      <p className="admin-stat__value">{value}</p>
      {hint ? <p className="admin-stat__hint muted">{hint}</p> : null}
    </>
  );

  if (to) {
    return (
      <AppLink href={to} className={className}>
        {content}
      </AppLink>
    );
  }

  return <article className={className}>{content}</article>;
}
